export enum NivelAcesso {
  SUPER_ADMIN = 0,
  ADMINISTRADOR = 1,
  GERENTE = 2,
  SUPERVISOR = 3,
  OPERADOR = 4,
  USUARIO_PADRAO = 5,
}

export interface User {
  id: number
  email: string
  name: string
  is_active: boolean
  nivel_acesso: number
  // Login original ThorJava (vw_uccaduser.login, até 16 caracteres)
  login_thor?: string | null
  iduser_thor?: number | null
  created_at?: string
  updated_at?: string
  descricao_superadmin?: string | null
  descricao_usuario?: string | null
}

export interface LoginRequest {
  email: string
  password: string
}

export interface LoginResponse {
  access_token: string
  refresh_token: string
  token_type: string
  expires_in: number
  user: User
}

export interface TokenResponse {
  access_token: string
  refresh_token: string
  token_type: string
  expires_in: number
}

export interface AuthState {
  user: User | null
  accessToken: string | null
  refreshToken: string | null
  isAuthenticated: boolean
}

export interface EmpresaInfo {
  id_empresa: number
  nome_empresa: string
  razao_social?: string | null
  cnpj?: string | null
  grupo_id?: number | null
  empresa_usuario_id?: number | null
  permitido?: boolean | null
  preferencias?: any
}

export interface UserContextResponse {
  nivel_acesso: number
  empresas: EmpresaInfo[]
  is_single_empresa: boolean
  can_act_as_super_admin: boolean
  can_act_as_admin: boolean
  can_act_as_user: boolean
}

export interface ContextSelectionRequest {
  role: 'SUPER_ADMIN' | 'ADMINISTRADOR' | 'USUARIO'
  empresa_id?: number | null
}

export interface UserContext {
  role: 'SUPER_ADMIN' | 'ADMINISTRADOR' | 'USUARIO'
  empresa_id?: number | null
  nivel_acesso_efetivo: number
  preferencias?: any
  empresa_nome?: string | null
  empresa_razao_social?: string | null
  empresa_cnpj?: string | null
}

